/** @type {import('tailwindcss').Config} */
module.exports = {
    content: [
      './public/controllers/**/*.php',
      './public/functions/**/*.php',
      './public/templates/**/*.php',
      './ecmascript/**/*.js',
    ],
    theme: {
      colors: {
        purple: '#5A245A',
        blue: '#185A7D',
        'blue-dark': '#0A3452',
        'blue-light': '#9CD0ED',
        red: '#E53E51',
        'red-light': '#EA6272',
        white: '#F9FDFF',
        black: '#000000',
        'gray-darker': '#27292D',
        'gray-dark': '#4D4F53',
        'gray-med': '#71727A',
        'gray-light': '#D5D6D2',
        'gray-lighter': '#EFF2F3',
        'gray-blue-light': '#E2E9F2',
      },
      extend: { },
    },
    plugins: [
      require('@tailwindcss/container-queries'),
    ],
  }
